<template>
  <div class="acceptance-card">
    <div
      class="acceptance-card__image"
      :style="project.thumbnail && `background-image: url(${project.thumbnail.url})`"
      :class="project.thumbnail ? 'bg-cover' : 'pa-10'"
    >
      <img
        v-if="!project.thumbnail || !project.thumbnail.url"
        class="acceptance-card__placeholder"
        src="@/assets/img/img-blank.svg"
      >
    </div>
    <v-chip
      class="mt-3"
      small
      color="primary"
    >
      <div class="font-weight-medium">
        {{ project.projectType }}
      </div>
    </v-chip>
    <div class="text-body-2 font-weight-bold mt-2">
      {{ project.name }}
    </div>
    <div class="grey--text mt-1">
      ID: {{ project.id }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.acceptance-card {
  max-width:100%;
  margin:8px;
  cursor: pointer;
  &__image {
    width:100%;
    height: 156px;
    background-color: $secondary;
    display:flex;
    align-items:center;
    justify-content: center;
  }
  &__placeholder {
    height:100%;
  }
}
</style>
